export const isTouchDevice = getIsTouchDevice();

function getIsTouchDevice() {
  return typeof window !== 'undefined' && 'ontouchstart' in window;
}
